import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanLeaveResetPassword {
  canExitResetPage: (nextUrl: string) => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class emailCodeFormGuard implements CanDeactivate<CanLeaveResetPassword> {
  canDeactivate(component: CanLeaveResetPassword, nextState: any): boolean | Observable<boolean> {
    const nextUrl = nextState?.url || '';
    return component.canExitResetPage(nextUrl);
  }
}
